import { render, staticRenderFns } from "./CourceStudentItem.vue?vue&type=template&id=2c7ab17f&scoped=true"
import script from "./CourceStudentItem.vue?vue&type=script&lang=js"
export * from "./CourceStudentItem.vue?vue&type=script&lang=js"
import style0 from "./CourceStudentItem.vue?vue&type=style&index=0&id=2c7ab17f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ab17f",
  null
  
)

export default component.exports